import { Controller, useFormContext } from "react-hook-form";
import {Button, Grid, Stack, TextField} from "@mui/material";

export default function Stepper03() {
    const { control, getValues, handleSubmit } = useFormContext();
    const onSubmit = getValues("funcoesAux.onSubmit");

    const handlePrevious = () => {
        const previousStep = getValues("funcoesAux.onBack");
        if (typeof previousStep === "function") previousStep();
    };

    return (
        <>
                <Grid container spacing={2} mb={1} alignItems='center'>

                    <Grid size={{xs: 12, md: 6}}>
                        <Controller
                            name="complemento"
                            control={control}
                            rules={{ required: "Complemento é obrigatória" }}
                            render={({ field, fieldState }) => (
                                <TextField
                                    {...field}
                                    label="Complemento"
                                    type="string"
                                    fullWidth
                                    required
                                    error={fieldState.invalid}
                                />
                            )}
                        />
                    </Grid>

                    <Grid size={{xs: 12, md: 6}}>
                        <Controller
                            name="modo_aplicacao"
                            control={control}
                            rules={{ required: "Modo de aplicação é obrigatório" }}
                            render={({ field, fieldState }) => (
                                <TextField
                                    {...field}
                                    label="Modo de aplicação"
                                    type="string"
                                    fullWidth
                                    required
                                    error={fieldState.invalid}
                                />
                            )}
                        />
                    </Grid>

                    <Grid size={{xs: 12, md: 6}}>
                        <Controller
                            name="manejo"
                            control={control}
                            rules={{ required: "Manejo é obrigatório" }}
                            render={({ field, fieldState }) => (
                                <TextField
                                    {...field}
                                    label="Manejo"
                                    type="string"
                                    fullWidth
                                    required
                                    error={fieldState.invalid}
                                />
                            )}
                        />
                    </Grid>

                    <Grid size={{xs: 12, md: 6}}>
                        <Controller
                            name="epoca_aplicacao"
                            control={control}
                            rules={{ required: "Época de aplicação é obrigatória" }}
                            render={({ field, fieldState }) => (
                                <TextField
                                    {...field}
                                    label="Época de aplicação"
                                    type="string"
                                    fullWidth
                                    required
                                    error={fieldState.invalid}
                                />
                            )}
                        />
                    </Grid>

                    <Grid size={{xs: 12, md: 4}}>
                        <Controller
                            name="grupo_quimico"
                            control={control}
                            rules={{ required: "Grupo químico é obrigatória" }}
                            render={({ field, fieldState }) => (
                                <TextField
                                    {...field}
                                    label="Grupo químico"
                                    type="string"
                                    fullWidth
                                    required
                                    error={fieldState.invalid}
                                />
                            )}
                        />
                    </Grid>

                </Grid>
            <Stack direction="row" justifyContent="flex-start" mt={2}>
                <Button variant="outlined" onClick={handlePrevious} sx={{ mr: 2 }}>
                    Voltar
                </Button>
                <Button variant="contained" onClick={handleSubmit(onSubmit)}>
                    Finalizar
                </Button>
            </Stack>
        </>
    );
}